import { Component, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { HostControlDirective, InputAutocomplete, InputError } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-text-input',
  imports: [TranslateModule, ReactiveFormsModule, MatFormField, MatFormFieldModule, MatInput],
  templateUrl: './text-input.component.html',
  hostDirectives: [HostControlDirective],
})
export class TextInputComponent {
  public accessorDirective = inject(HostControlDirective);
  @Input() public autocomplete: InputAutocomplete = 'off';
  @Input() public errors: InputError[] = [];
  @Input() public hideRequiredMarker = true;
  @Input() public hint: string | undefined = '';
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public type: 'text' | 'email' = 'text';
}
